import React from 'react';
import Button from './Button';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, Button.extend`
  color: ${theme.colors.white};
  background: ${theme.colors.action};

  &::after {
    border-color: ${theme.colors.white} !important;
  }

  ${({ inverse }) => inverse && `
    background: ${theme.colors.white};
    color: ${theme.colors.action};

    &::after {
      border-color: ${theme.colors.action} !important;
    }
  `}
`.withComponent(({
  inverse, // strip
  ...props
}) => <Button {...props} />));



// WEBPACK FOOTER //
// ./src/components/buttons/ActionButton.js